export const pageTextSources = ['pageProduct', 'pageDevice', 'pageDeviceId']
const text = (value, fallback) => typeof value === 'string' ? value : fallback

export function pageTextSettings (option = {}) {
  const source = pageTextSources.includes(option.textSource) ? option.textSource : 'data'
  const device = source === 'pageDevice' || source === 'pageDeviceId', identifier = source === 'pageDeviceId'
  const label = device ? identifier ? '设备编号' : '设备名称' : '产品名称'
  const key = device ? identifier ? 'deviceCodeText' : 'deviceText' : 'productText'
  return { source, device, identifier, label, contextKey: device ? 'deviceId' : 'productId',
    exampleKey: key + 'Example', emptyKey: key + 'Empty',
    example: text(option[key + 'Example'], label), empty: text(option[key + 'Empty'], '—') }
}
